"use client";

import { Atom, Beaker, Box, Cpu, Droplet, Flame, Layers, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MisiNYValores() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const materials = [{
    name: "Integridad",
    description: "Actuamos con rectitud y honestidad en cada proceso de transformación y comercialización de acero.",
    tensile: "ALTA",
    temp: "CONSTANTE",
    Icon: Shield
  }, {
    name: "Innovación",
    description: "Buscamos constantemente nuevas tecnologías para mejorar la eficiencia en la industria siderúrgica.",
    tensile: "DINÁMICA",
    temp: "PROGRESIVA",
    Icon: Cpu
  }, {
    name: "Sostenibilidad",
    description: "Comprometidos con el medio ambiente mediante el reciclaje y procesos de bajo impacto ecológico.",
    tensile: "VITAL",
    temp: "RENOVABLE",
    Icon: Droplet
  }, {
    name: "Calidad",
    description: "Garantizamos productos que cumplen con los más altos estándares internacionales de resistencia.",
    tensile: "CERTIFICADA",
    temp: "ESTÁNDAR",
    Icon: Layers
  }, {
    name: "Seguridad",
    description: "Priorizamos el bienestar de nuestros colaboradores con protocolos rigurosos en cada planta.",
    tensile: "MÁXIMA",
    temp: "CONTROLADA",
    Icon: Box
  }, {
    name: "Resiliencia",
    description: "Capacidad de adaptación ante los retos del mercado global manteniendo nuestra solidez estructural.",
    tensile: "EXTREMA",
    temp: "ADAPTABLE",
    Icon: Atom
  }, {
    name: "Eficiencia",
    description: "Optimización de recursos para entregar soluciones de acero competitivas y en tiempos récord.",
    tensile: "ÓPTIMA",
    temp: "AGILIZADA",
    Icon: Beaker
  }, {
    name: "Pasión",
    description: "Entusiasmo por construir el futuro de México a través de la industria del acero y sus derivados.",
    tensile: "FUERTE",
    temp: "INTENSA",
    Icon: Flame
  }];
  return <section data-section-id="2254" id="misión-y-valores" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-6">
            <p className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase mb-6" style={{
            color: "var(--primary)"
          }}>
              Nuestra Identidad
            </p>
            <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-foreground">
              Forjando el futuro con valores sólidos.
            </h2>
          </div>
          <div className="md:col-span-6 md:pt-4">
            <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl font-default">
              En Kalisch Acero, nuestra misión es liderar la industria mediante la excelencia operativa y un compromiso inquebrantable con la ética, impulsando el desarrollo de infraestructuras duraderas.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {materials.map((material, i) => {
          const Icon = material.Icon;
          return <div data-index={i} key={material.name} className="group relative rounded-lg border border-border bg-card p-7 md:p-8 transition-all duration-300 ease-out hover:-translate-y-1 shadow-md hover:shadow-xl" style={{
            backgroundColor: "var(--card)"
          }}>
                {}
                <div className="mb-7 inline-flex h-[60px] w-[60px] items-center justify-center rounded-md transition-colors duration-300" style={{
              backgroundColor: "var(--muted)"
            }}>
                  <Icon className="h-6 w-6 transition-colors duration-300 group-hover:text-primary-foreground" strokeWidth={1.5} style={{
                color: "var(--primary)"
              }} />
                  <span className="absolute pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 h-[60px] w-[60px] rounded-md -z-0" aria-hidden="true" />
                </div>

                {}
                <style>{`
                  .group:hover [data-badge-fill="${i}"] {
                    background-color: var(--primary);
                  }
                `}</style>

                {}
                <h3 className="font-default font-bold text-[28px] leading-tight text-card-foreground mb-3">
                  {material.name}
                </h3>

                {}
                <p className="text-sm leading-relaxed text-muted-foreground mb-8 font-default">
                  {material.description}
                </p>

                {}
                <div className="pt-5 border-t border-border">
                  <p className="font-mono text-xs tracking-wider uppercase" style={{
                color: "var(--muted-foreground)"
              }}>
                    <span style={{
                  color: "var(--accent)"
                }}>NIVEL:</span>{" "}
                    <span className="text-foreground">{material.tensile}</span>
                    <span className="mx-2 opacity-50">·</span>
                    <span style={{
                  color: "var(--accent)"
                }}>ESTADO:</span>{" "}
                    <span className="text-foreground">{material.temp}</span>
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>

      {}
      <style>{`
        #misión-y-valores .group:hover {
          border-color: var(--primary);
        }
        #misión-y-valores .group:hover .inline-flex {
          background-color: var(--primary) !important;
        }
      `}</style>
    </section>;
}